<template>
	<v-dialog
		v-model='dialog'
		:width='width'
	>
		<template v-slot:activator='{ on, attrs }'>
			<v-btn
				v-if='isActive'
				color='primary'
				class='font-weight-bold search-order-button'
				depressed
				text
				small
				v-bind='attrs'
				v-on='on'
			>
				Suchauftrag anlegen
				<v-icon class='ml-2' size='12'>
					far fa-save
				</v-icon>
			</v-btn>
		</template>
		<v-card v-if='!isSubmitted'>
			<v-card-title>
				<span>Suchauftrag anlegen</span>
				<v-spacer />
				<v-icon class='ml-2' size='12' @click='handleDialog'>
					far fa-times
				</v-icon>
			</v-card-title>
			<v-card-text>
				<p><strong>Deine angewandten Filter:</strong></p>
				<div class='mb-3'>
					<v-chip
						v-for='(chip, index) in chips'
						:key='index'
						class='primary--text beige'
						:class='$vuetify.breakpoint.lgAndUp ? "font-weight-bold" : "mobile-chip"'
						small
						@click='removeChip(index)'
					>
						{{ chip.text }}
						<v-icon class='ml-2' color='primary' size='14'>
							{{ $vuetify.breakpoint.mdAndDown ? 'fal fa-times' : 'far fa-times' }}
						</v-icon>
					</v-chip>
				</div>
				<p><strong>Wie oft sollen wir dich über deine Suche informieren?</strong></p>
				<v-radio-group v-model='notificationInterval' :error-messages='intervalError'>
					<v-radio
						v-for='i in intervals'
						:key='i.value'
						color='red'
						:value='i.value'
					>
						<template v-slot:label>
							<div class='radio-label'>
								{{ i.label }}
							</div>
						</template>
					</v-radio>
				</v-radio-group>
				<p><strong>Bitte nenne uns deine E-Mail-Adresse über die wir dich benachrichten:</strong></p>
				<v-row>
					<v-col sm='12' md='8'>
						<v-text-field
							v-model='emailInput'
							placeholder='Deine E-Mail Adresse'
							outlined
							class='mail-input'
							:error-messages='mailError'
						/>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					class='abort-button'
					text
					@click='handleDialog'
				>
					Abbrechen
				</v-btn>
				<v-btn
					class='add-more-button'
					text
					@click='handleDialog'
				>
					Mehr Filter hinzufügen
				</v-btn>
				<v-btn
					class='submit-button'
					text
					@click='submit'
				>
					Suchauftrag aktivieren
				</v-btn>
			</v-card-actions>
		</v-card>
		<v-card v-else>
			<v-card-title>
				<span>Suchauftrag anlegen</span>
				<v-spacer />
				<v-icon class='ml-2' size='12' @click='handleDialog'>
					far fa-times
				</v-icon>
			</v-card-title>
			<v-card-text>
				<v-row class='success-row'>
					<v-col offset='3' cols='1' class='d-flex justify-center align-center'>
						<v-icon class='success-icon' size='21'>
							fas fa-check-circle
						</v-icon>
					</v-col>
					<v-col sm='12' md='6' class='mt-auto mb-auto'>
						<v-row><strong>Dein Suchauftrag wurde gespeichert!</strong><br></v-row>
						<v-row>Du erhältst in Kürze eine Bestätigungsmail.</v-row>
					</v-col>
				</v-row>
				<v-card-text />
				<v-card-actions>
					<v-spacer />
					<v-btn
						class='submit-button'
						text
						@click='handleDialog'
					>
						Schließen
					</v-btn>
				</v-card-actions>
			</v-card-text></v-card>
	</v-dialog>
</template>

<script>

  export default {
    name: 'OptionList',
    components: {},
    props: {
      chips: {
        default: function () {
          return []
        },
        required: false,
        type: Array
      }
    },
    data() {
      return {
        isBusiness: false,
        dialog: false,
        isMobile: false,
        notificationInterval: null,
        intervalError: '',
        emailInput: '',
        mailError: '',
        isSubmitted: false,
        intervals:  [
          { value: 'daily', label: 'Täglich'},
          { value: 'weekly', label: 'Einmal in der Woche'},
          { value: 'monthly', label: 'Einmal im Monat'}
        ]
    }
    },
    computed: {
      width(){
        if(this.$vuetify.breakpoint.mobile){
          return 'auto';
        }
        return 740;
      },
      isActive(){
        return !(process.env.VUE_APP_ENV == 'production')
      }
    },
    beforeDestroy () {
      if (typeof window === 'undefined') return
      window.removeEventListener('resize', this.onResize, { passive: true })
    },
    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },
    methods: {
      removeChip(index){
        this.chips.splice(index, 1)
      },
      handleDialog(){
        this.dialog = !this.dialog
        this.isSubmitted = false
      },
      onResize() {
        this.isMobile = window.innerWidth < 600
      },
      async submit() {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const mailCheck = re.test(String(this.emailInput).toLowerCase())
        let chipText = ''

        if(!mailCheck){
          this.mailError = 'Bitte trage eine gültige E-Mail-Adresse ein. Die E-Mail-Adresse muss ein „@„ enthalten.'
        } else {
          this.mailError = ''
        }

        if(!this.notificationInterval){
          this.intervalError = 'Bitte wähle einen Intervall aus.'
        } else {
          this.intervalError = ''
        }

        this.chips.map(function(object) {
          if(chipText.length === 0){
            chipText = object.text
          } else {
            chipText = `${chipText} + ${object.text}`
          }
        })
        if(this.notificationInterval && mailCheck){
          let formData = new FormData();
          let date = new Date();
          let data = {
            email: this.emailInput,
            name: `Suchauftrag vom ${('0' + (date.getDate() + 1)).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(-2)}.${date.getFullYear()}`,
            filter_url: window.location.href,
            export_type: this.notificationInterval.toUpperCase(),
            formatted_text: chipText
          };
          for( const [key, val] of Object.entries(data)) {
            formData.set(key, val);
          }
          const response = await fetch(`${process.env.VUE_APP_API_URL}/v1.0/de-de/search-order`, {
            method: 'POST',
            cors: true,
            body: formData
          })

          this.isSubmitted = true
          this.emailInput = ''
          this.notificationInterval = null
        }
      }
    }
  }
</script>

<style scoped lang='scss'>
.submit-button {
  border-radius: 3px;
  border: solid 1px red;
  background-color: red;
  color: #fff
}

.error-text {
  font-size: 11px;
  color: #e02b40;
}

.add-more-button {
  border-radius: 3px;
  box-shadow: 0 0 3px 1px rgba(185, 185, 185, 0.23);
  border: solid 0.2px #b9b9b9;
  background-color: #fff;
}

.abort-button {
  font-weight: bold;
}

.radio-label  {
  font-size: 14px !important;
  font-weight: normal !important;
  letter-spacing: normal !important;
  color: #000 !important;
}

.success-icon {
  color: #2b9a00;
}

.success-row {
  height: 200px;
}

.v-card__title {
  border-bottom: 1px solid #d0d0d0;
}
</style>